/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CommunicationLog from './communication-log';
import CommunicationLogDetail from './communication-log-detail';
import CommunicationLogUpdate from './communication-log-update';
import CommunicationLogDeleteDialog from './communication-log-delete-dialog';

const CommunicationLogRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CommunicationLog />} />
    <Route path="new" element={<CommunicationLogUpdate />} />
    <Route path=":id">
      <Route index element={<CommunicationLogDetail />} />
      <Route path="edit" element={<CommunicationLogUpdate />} />
      <Route path="delete" element={<CommunicationLogDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CommunicationLogRoutes;
